import { MAP_STYLES } from "@utils/maps/mapStyles";
import { IconRulerMeasure } from "@tabler/icons-react";
import "@assets/css/maps/MapStyleOverlayPanel.css";

function MapStyleOverlayPanel({
  selectedStyle,
  onStyleChange,
  is3DEnabled,
  onToggle3D,
  isMeasurementEnabled,
  measurementDistanceKm,
  measurementPointCount,
  onToggleMeasurement,
}) {
  const formattedMeasurementDistance =
    measurementDistanceKm < 1
      ? `${Math.round(measurementDistanceKm * 1000)} m`
      : `${measurementDistanceKm?.toFixed(
          measurementDistanceKm >= 10 ? 2 : 3,
        )} km`;
  const measurementMessage =
    measurementPointCount === 0
      ? "Click the starting point on the map."
      : measurementPointCount === 1
        ? "Click the destination point."
        : formattedMeasurementDistance;

  return (
    <div className="map-style-overlay" onClick={(event) => event.stopPropagation()}>
      <label className="field-label map-style-label">
        Map style
        <select
          className="field-input select-control"
          value={selectedStyle}
          onChange={(event) => onStyleChange(event.target.value)}
        >
          {MAP_STYLES.map((style) => (
            <option key={style.key} value={style.value}>
              {style.label}
            </option>
          ))}
        </select>
      </label>
      <label className="field-checkbox map-style-3d">
        <input
          type="checkbox"
          checked={is3DEnabled}
          onChange={(event) => onToggle3D(event.target.checked)}
        />
        View 3D
      </label>
      <div className="map-style-measurement">
        <button
          type="button"
          className={`map-style-measurement-btn ${
            isMeasurementEnabled ? "active" : ""
          }`}
          onClick={() => onToggleMeasurement(!isMeasurementEnabled)}
          title={isMeasurementEnabled ? "Stop measuring" : "Measure distance"}
        >
          <IconRulerMeasure size={18} stroke={1.8} />
          <span>{isMeasurementEnabled ? "Stop measuring" : "Measure distance"}</span>
        </button>
        {isMeasurementEnabled && (
          <div className="map-style-measurement-result">
            <span>{measurementMessage}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default MapStyleOverlayPanel;
